import React, { type PropsWithChildren } from 'react';

import { Button } from '../button/button';
import { NEW_WINDOW_FEATURES, SHARE_URLS } from './contants';

export type SocialShareButtonProps = PropsWithChildren<{
  target: keyof typeof SHARE_URLS;
  url: string;
  className?: string;
}>;

export const SocialShareButton = ({
  children,
  className,
  target,
  url,
}: SocialShareButtonProps) => {
  const onClick = () => {
    window.open(`${SHARE_URLS[target]}${url}`, 'window', NEW_WINDOW_FEATURES);
  };

  return (
    <Button className={className} onClick={onClick}>
      {children}
    </Button>
  );
};
